import { createStore } from 'owa-satcheljs';
import type { AccountSelectOptionState } from './schema/AccountSelectOptionState';

const defaultExport: () => AccountSelectOptionState = createStore<AccountSelectOptionState>(
    'accountSelectOption',
    {
        accountKey: null,
        sourceId: null,
        isApplyAllSelected: false,
    }
);
export default defaultExport;
